import React from 'react'
import fetcher from '@byma/shared/helpers/fetcher'
import Input from '@byma/shared/components/Input'
import Loader from '@byma/shared/components/Loader'
import useToastContext from "@byma/shared/hooks/useToastContext";
import { isValidEmail, isValidCPF } from '@byma/shared/helpers/validators'


function SearchUser({ onSuccess }) {
    const [query, setQuery] = React.useState('')
    const addToast = useToastContext()
    const [isSearching, setIsSearching] = React.useState(false)
    const [error, setError] = React.useState(false)

    async function handleSearch(e) {
        e.stopPropagation()
        setError(false)
        if (e.key && e.key !== 'Enter') {
            return false;
        }
        if (!query || query.length === 0 || (!isValidEmail(query) && !isValidCPF(query))) {
            return setError('Busque apenas por email ou CPF')
        }
        setIsSearching(true)
        try {
            const user = await fetcher('/api/users/publicLookup?query=' + query)
            setIsSearching(false)
            return onSuccess(user.result)
        } catch (e) {
            addToast('Usuário não encontrado', 'error')
            setIsSearching(false)
            return onSuccess(false)
        }
    }

    return (
        <div className="w-full">
            {isSearching ? <Loader /> : (
                <Input onChange={(event) => setQuery(event.target.value)} type="text" name="userEmail" label='Digite o email ou CPF do usuário' onBlur={handleSearch} error={error} onKeyPress={handleSearch} />
            )}
        </div>


    )
}
export default SearchUser
